import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import { crmValidator } from 'helpers';
import lodash from 'lodash';

// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
// import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker.jsx";

import RichEditor from "components/RichEditor/RichEditor.jsx";

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";

import { alert, store, plugins, normalize } from 'helpers';
import { stepcountsConstants } from '../../constants';
import StepCountTypeCode from './StepCountTypeCode.jsx';
// import StepCountTypePurchaseAmount from './StepCountTypePurchaseAmount.jsx';
// import StepCountTypeProduct from './StepCountTypeProduct.jsx';
import { stepCountsAction } from 'actions';
import * as FormValidator from './validate/FormValidator';

// Reward
import FormGift from "./FormReward/FormGift.jsx";
import FormPoint from "./FormReward/FormPoint.jsx";

import i18n from "i18n";

const FORM_NAME = "FORM_STEPCOUNTS";

const style = {
	customCardContentClass: {
		paddingLeft: "0",
		paddingRight: "0",
	},
	cardFooter: {
		padding: "15px",
		textAlign: "right",
		paddingTop: "0",
		margin: "0",
	},
	labelHorizontalCenter: {
		float: "right",
		color: "rgba(0, 0, 0, 0.26)",
		cursor: "pointer",
		display: "inline-flex",
		fontSize: "14px",
		lineHeight: "1.428571429",
		fontWeight: "400",
		paddingTop: "39px",
		marginRight: "0",
	},
	checkboxAndRadio: {
		position: "relative",
		display: "block",
		marginTop: "10px",
		marginBottom: "10px",
	},
	checkboxAndRadioHorizontal: {
		position: "relative",
		display: "block",
		"&:first-child": {
			marginTop: "10px",
		},
		"&:not(:first-child)": {
			marginTop: "-14px",
		},
		marginTop: "0",
		marginBottom: "0",
	},
	paddingLeft32: {
		paddingLeft: "32px",
	},
	borderDashed: {
		border: "dashed 1px #ccc",
		padding: "15px 0",
		width: "100%",
		margin: "15px 15px",
	},
};

const listRewardType = [
    { value: "gift", label: "Gift" },
    { value: "point", label: "Point" }
 ]

// const form_validate = {
//     "name": {
//         rules: {
//             required: true
//         },
//         messages: {
//             required: "Please enter Step Count's name"
//         },
//         alert: "Please enter Step Count's name"
//     },
//     "status": {
//         rules: {
//             required: true
//         },
//         messages: {
//             required: 'Please enter Status'
//         },
//         alert: "Please enter Status"
//     },
//     "startDate": {
//         rules: {
//             required: true
//         },
//         messages: {
//             required: 'Please enter Start Date'
//         },
//         alert: "Please enter Start Date"
//     }
// }

const validate = (values) => {
	const errors = crmValidator.validateByRulesList(
		{
			...FormValidator.form_validate,
			...FormValidator.reward_validate,
			...FormValidator.detail_validate
		},
		values
	);
	return errors;
};

class StepCountsForm extends React.Component {
    getProductList(keyword) {
        const { dispatch } = this.props;
        let reqParams = "sortBy=updated_at&sortDir=desc&status=Active"
        if (keyword) {
            reqParams += `&keyword=${keyword}`
        }
        dispatch(stepCountsAction.getListsProduct(reqParams))
    }

    getFormSubmitParams = (values, formMode) => {
        const { allProductList, FORM_STEPCOUNTS } = this.props;

        let products = [];
        let registeredFields = FORM_STEPCOUNTS.registeredFields
        console.log('registeredFields', registeredFields)
        lodash.forEach(values.productAmount, function (value, key) {
            if (lodash.has(registeredFields, `productAmount[${key}]`) && lodash.has(registeredFields, `productPriority[${key}]`)) {
                products.push({
                    productId: key,
                    productSku: lodash.find(allProductList, { '_id': key }).skuId,
                    amount: value,
                    priority: values.productPriority[key]
                })
            }
        })
        // console.log('products 1', products);
        // Sort by priority before save
        products.sort((a, b) => {
            return a.priority - b.priority;
        });
        // console.log('products 2', products);
        // return false;
        const endDate = () => {
            if (lodash.has(values, 'endDate')) {
                return plugins.dateFormatForDB(values.endDate)
            } else {
                return undefined
            }
        }
        
        let result = {
            data: {
                name: values.name,
                products: products,
                message: values.message,
                description: btoa(encodeURIComponent(values.description)),
                termAndCondition: btoa(encodeURIComponent(values.termAndCondition)),
                startDate: plugins.dateFormatForDB(values.startDate),
                endDate: endDate(),
                status: values.status,
                rewardType: values.rewardType,
                rewardDetail: {
                    pointEarn: values.rewardDetail.pointEarn,
                    title: values.rewardDetail.title,
                    description: values.rewardDetail.description,
                    imgPath: values.rewardDetail.imgPath
                }
            },
            rewardDetailImg: values.rewardDetailImg
        }

        if (formMode === "edit") {
            result._id = values._id
        }

        return result;

    }

    handleSubmit = (values) => {
        console.log('values', values);
        const { dispatch, formMode } = this.props;
        let params = this.getFormSubmitParams(values, formMode)
        console.log('params', params);
        if (params) {
            if (formMode === "add") {
                dispatch(stepCountsAction.addStepCounts(params))
            } else if (formMode === "edit") {
                dispatch(stepCountsAction.updateStepCounts(params))
            }
        }
    }

    renderFormType() {
        const { FORM_STEPCOUNTS, formMode } = this.props;

        let { readOnly } = this.props
        if (formMode === `add`) {
            readOnly = false
        } else if (formMode === `edit` && !readOnly) {
            readOnly = false
        } else {
            readOnly = true
        }

        return (<StepCountTypeCode readOnly={readOnly} />);

        // if (!lodash.has(FORM_STEPCOUNTS, 'values.type')) {
        //     return null;
        // } else {
        //     const formtype = FORM_STEPCOUNTS.values.type;
        //     switch (formtype) {
        //         case "code": {
        //             return (<StepCountTypeCode readOnly={readOnly} />);
        //         }
        //         case "purchaseAmount": {
        //             return (<StepCountTypePurchaseAmount readOnly={readOnly} props={this.props} FORM_NAME={FORM_NAME} />);
        //         }
        //         case "product": {
        //             return (<StepCountTypeProduct readOnly={readOnly} props={this.props} FORM_NAME={FORM_NAME} />);
        //         }
        //         default: return null;
        //     }
        // }
    }

    componentDidMount() {
        const { dispatch }  = this.props
        this.getProductList();
        // dispatch(stepCountsAction.getLuckyDrawRewardSetList())
    }
    render() {
        const { formOpen, formMode, classes, dispatch, handleSubmit, FORM_STEPCOUNTS, package_features } = this.props
        let { readOnly } = this.props
        if (formMode === `add`) {
            readOnly = false
        } else if (formMode === `edit` && !readOnly) {
            readOnly = false
        } else {
            readOnly = true
        }

        let componentReward = null;

        if (FORM_STEPCOUNTS.values.rewardType === "gift") {
            componentReward = <FormGift props={this.props} FORM_NAME={FORM_NAME} />;
        } else if (FORM_STEPCOUNTS.values.rewardType === "point") {
            componentReward = (
                <FormPoint props={this.props} FORM_NAME={FORM_NAME} />
            );
        }

        // let stepCountTypeList = plugins.getStepCountListByPacekageFeature(package_features)

        return (
            <Dialog
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                open={formOpen}
                keepMounted
                aria-labelledby="modal-slide-title"
                aria-describedby="modal-slide-description"
                fullWidth={true}
                maxWidth={['product', 'purchaseAmount'].indexOf(FORM_STEPCOUNTS.values.type) >= 0 ? "lg" : "sm"}
                disableRestoreFocus={true}
                scroll="body">

                <DialogTitle
                    disableTypography
                    className={classes.modalHeader}>
                    <h4 className={classes.modalTitle}><b>{formMode === 'add' ? 'Add Step Count' : (readOnly ? 'Step Count Info' : 'Edit Step Count')}</b></h4>
                </DialogTitle>
                <form name={FORM_NAME} onSubmit={handleSubmit(this.handleSubmit)}>
                    <DialogContent className={classes.modalBody}>

                        <GridContainer>
                            <GridItem xs={12} sm={6} md={8}>
                                <Field
                                    id='rule-name-input'
                                    name="name"
                                    component={CustomInput}
                                    type="text"
                                    labelText="Name *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    disabled={readOnly}
                                />
                                {formMode === "edit" ?
                                    <Field
                                        id='rule-id-input'
                                        name="_id"
                                        component="input"
                                        type="hidden"
                                    />
                                    : null}
                            </GridItem>
                            <GridItem xs={12} sm={6} md={4}>
                                <Field
                                    id='rule-status-select'
                                    name="status"
                                    component={CustomSelect}
                                    type="text"
                                    labelText="Status *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    optionsList={[
                                        {
                                            value: "Active",
                                            label: "Active"
                                        },
                                        {
                                            value: "Inactive",
                                            label: "Inactive"
                                        }
                                    ]}
                                    disabled={readOnly}
                                />
                            </GridItem>
                        </GridContainer>
                        <GridContainer>
                            <GridItem xs={12} sm={4} md={4}>
                                <Field
                                    id='start-date-select'
                                    name="startDate"
                                    component={CustomDatePicker}
                                    type="text"
                                    maxDate={FORM_STEPCOUNTS.values.endDate}
                                    labelText="Start Date *"
                                    dateFormat="DD-MMM-YY"
                                    timeFormat="HH:mm"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={4} md={4}>
                                <Field
                                    id='end-date-select'
                                    name="endDate"
                                    minDate={FORM_STEPCOUNTS.values.startDate}
                                    component={CustomDatePicker}
                                    type="text"
                                    labelText="End Date"
                                    dateFormat="DD-MMM-YY"
                                    timeFormat="HH:mm"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                />
                            </GridItem>
                        </GridContainer>

                        <GridContainer>
                            <GridItem xs={12} sm={6} md={8}>
                                <Field
                                    id='rule-message-input'
                                    name="message"
                                    component={CustomInput}
                                    type="text"
                                    labelText="Message *"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    disabled={readOnly}
                                />
                            </GridItem>
                        </GridContainer>


                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <label htmlFor="description-input">Description</label>
                                <Field
                                    id='description-input'
                                    name="description"
                                    component={RichEditor}
                                    disabled={readOnly}
                                />
                                <br />
                            </GridItem>
                        </GridContainer>

                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <label htmlFor="termAndCondition-input">Term & Condition</label>
                                <Field
                                    id='termAndCondition-input'
                                    name="termAndCondition"
                                    component={RichEditor}
                                    disabled={readOnly}
                                />
                                <br />
                            </GridItem>
                        </GridContainer>
                        
                        {this.renderFormType()}

                        <GridContainer>
							<div style={style.borderDashed}>
								<GridItem xs={12} sm={12} md={12}>
									<legend>
										<b>{i18n.t("campaign.reward")}</b>
									</legend>
									<GridContainer>
										<GridItem xs={12} sm={6} md={3}>
											<Field
												name="rewardType"
												component={CustomSelect}
												type="text"
												labelText={i18n.t("label.reward_type")}
												formControlProps={{
													fullWidth: true,
												}}
												disabled={readOnly || formMode === "edit"}
												optionsList={listRewardType}
											/>
										</GridItem>
									</GridContainer>
									{componentReward}
								</GridItem>
							</div>
						</GridContainer>
                    </DialogContent>
                    <DialogActions
                        className={classes.modalFooter}>
                        {!readOnly ?
                            <Button
                                id='submit-btn'
                                type="submit"
                                disabled={false}
                                style={{ marginRight: "10px" }}
                                color="primary">
                                {formMode === "edit" ? "Update" : "Submit"}
                            </Button>
                            : ''
                        }
                        <Button
                            id='cancel-btn'
                            type="button"
                            onClick={() => {
                                dispatch({ type: stepcountsConstants.CLOSE_FORM_STEP_COUNTS });
                            }}
                            color="white">
                            Cancel
        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        )
    }

}

function mapStateToProps(state) {
    const { formOpen, formMode, productList, allProductList, joinedProductRows, joinedProductList, allShopListSelected, productListMaster, luckyDrawRewardSet, rewardImagePreview } = state.stepcounts;
    const { FORM_STEPCOUNTS } = state.form;
    const { package_features } = state.authentication
    return {
        formOpen, formMode, FORM_STEPCOUNTS, allProductList, productList, joinedProductRows, joinedProductList, allShopListSelected, productListMaster, package_features, luckyDrawRewardSet, rewardImagePreview
    };
}

const connectCampaignForm = connect(mapStateToProps)(StepCountsForm);

export default reduxForm({
    form: FORM_NAME,
    validate: validate,
    enableReinitialize: true,
    onSubmitFail: (errors, dispatch, props) => {

        let globalStore = store.getState();
        let formMeta = globalStore.form[FORM_NAME];

        if (formMeta.values.type === "product") {
            for (let j in errors) {
                if (j == 'singleProductNameSkuSelect' || j == 'singleProductPointInput' || j == 'singleProductQuantityInput') {
                    let temp = lodash.get(errors, j)
                    if (temp.length > 0) {
                        let obj = temp.find(o => lodash.isUndefined(o) === false);
                        alert(dispatch, 'error', obj)
                    }
                }
                else {
                    crmValidator.alertFirstInvalid(FORM_NAME, errors, FormValidator.form_validate);
                }
            }
        } else {
            crmValidator.alertFirstInvalid(FORM_NAME, errors, FormValidator.form_validate);
            if (formMeta.values.type === "code" && !globalStore.alert.isShow) {
                if (lodash.has(errors, 'stepCountCode') && !formMeta.values.stepCountCode) {
                    alert(dispatch, 'error', 'Please enter Earn Rule Code')//ท่านยังไม่ได้กรอก Earn Rule Code กรุณากรอกข้อมูลให้ครบถ้วน
                } else if (lodash.has(errors, 'selectedProductCount')) {
                    alert(dispatch, 'error', 'Please select at least a product')
                }
            }
        }
    }
})(withStyles(modalStyle)(connectCampaignForm))